<template>
  <v-container grid-list-md style="max-width:2000px">
      <v-layout row wrap >
          <v-flex xs12 sm6 md4 v-for="group in groups" :key="group._id">

      <web-group-card :group='group' :collections='collections' > </web-group-card>

          </v-flex>
      </v-layout>
  </v-container>
</template>


<script>
export default {
  data() { 
      return {

      }
  },
  computed: {
         isLoggedIn()
      {
        return this.$store.getters.isLoggedIn
      },
    popularArtefacts(){
      return this.$store.getters.loadPopularArtefacts;
    },
      collections(){
            return this.$store.getters.loadAllCollections;
      },
      artefacts() {
            return this.$store.getters.loadArtefacts;
      },
      groups() {
      return this.$store.getters.loadGroups;
    },
       isAdmin()
    {
      return this.$store.getters.isAdmin
    }
  },
  methods: {
    showContent(collection) { 

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for(i=0; i< this.artefacts.length; i++) { 
        if(this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
            return true;
        }
      }
      return false;
    },
    showContentGroup(group) { 

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for(i=0; i< this.collections.length; i++) { 
        if(this.collections[i].groups.indexOf(group.title) > -1) {
            return true;
        }
      }
      return false;
    },
          minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    },
    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';
        
    //     }
    //     else 
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }
    //   },
    
   isLast(idart,coltitle){
      var j,k=[];
  
      
        for (j = 0; j<this.artefacts.length;j++)
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1)
        k.push(this.artefacts[j]._id);

    if(k[k.length-1] == idart)
    return true
    else return false

    }
  },
  mounted () {
     document.title = "Groups";
    window.scrollTo(0, 0);
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Common/Groups.vue